<template>
  <a-layout-content>
    <a-form-model ref="promotionForm" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="活动名称" prop="name" ref="name">
        <a-input v-model="input.name" type="text" />
      </a-form-model-item>
      <a-form-model-item label="外链地址" prop="url">
        <a-input v-model="input.url" />
      </a-form-model-item>
      <a-form-model-item label="排序字段" prop="sort">
        <a-input-number v-model="input.sort" />
      </a-form-model-item>
      <a-form-model-item label="是否开启">
        <a-switch checked-children="开启" un-checked-children="关闭" :checked="input.state == 1"
          @change="swichstate($event, 'state')" />
        活动是否处于开启状态，若关闭，则用户无法申请该活动
      </a-form-model-item>
      <a-form-model-item label="是否显示">
        <a-switch checked-children="显示" un-checked-children="隐藏" :checked="input.showpc == 1"
          @change="swichstate($event, 'showpc')" />
        活动是否在首页展示，若关闭，则活动在首页不显示
      </a-form-model-item>
      <a-form-model-item label="手机显示">
        <a-switch checked-children="显示" un-checked-children="隐藏" :checked="input.showphone == 1"
          @change="swichstate($event, 'showphone')" />
        活动是否在手机首页展示，若关闭，则活动在首页不显示
      </a-form-model-item>
      <a-form-model-item label="限制次数" prop="limitcount">
        <a-input-number v-model="input.limitcount" />
      </a-form-model-item>
      <a-form-model-item label="限制提示" prop="limittip">
        <a-input v-model="input.limittip" />
      </a-form-model-item>
      <a-form-model-item label="是否开放活动申请">
        <a-switch checked-children="开放" un-checked-children="关闭" :checked="input.activiesapply == 1"
          @change="swichstate($event, 'activiesapply')" />
      </a-form-model-item>
      <a-form-model-item label="上传内文图片">
        <a-space :size="5">
          <a-upload :before-upload="UploadImg" :file-list="imgfile" :remove="imgRemove">
            <a-button> <a-icon type="upload" /> 上传内文图片 </a-button>
          </a-upload>
        </a-space>
        <a-space :size="5">
          <a-button v-if="imgfile.length>0" @click="UploadOK(1)"> 上传 </a-button>
          <a-button v-if="imgurl!=''" @click="copyContent(imgurl)"> 复制图片链结 </a-button>
        </a-space>
      </a-form-model-item>
      <a-form-model-item label="链接至影片">
        <a-space :size="5">
          <a-switch style="margin-left: 10px;" checked-children="开放" un-checked-children="关闭"
            :checked="input.videostate == 1" @change="swichstate($event, 'videostate')" />
          <a v-if="input.videostate==1" @click="uploadvideomodel">上传影片</a>
        </a-space>
      </a-form-model-item>
      <a-form-model-item style="z-index: 1;" label="活动内容" prop="pcEditor">
        <editor v-model="input.pcEditor"></editor>
      </a-form-model-item>
      <a-form-model-item style="z-index: 1;" label="手机端活动内容" prop="phoneEditor">
        <editor v-model="input.phoneEditor"></editor>
      </a-form-model-item>
      <a-button type="primary" style="margin-left: 25%" @click="save()">
        提交
      </a-button>
    </a-form-model>

    <!-- 对话框 ------------------------------------->
    <a-modal v-model="visible" title="上传影片" @ok="modelOK">
      <a-form-model :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }">
        <a-form-model-item label="上传影片">
          <a-upload :before-upload="UploadVideo" :file-list="videofile" :remove="videoRemove">
            <a-button> <a-icon type="upload" /> 上传影片
              <a-icon style="color: green;" v-if="input.contentvideo!=''" type="check" />
              <a-icon style="color: red;" v-else type="close" /></a-button>
          </a-upload>
          <a-button v-if="videofile.length>0" @click="UploadOK(2)"> 上传 </a-button>
          <br />
          <span style="color: red;">1、最大可上传25MB之mp4影片</span>
          <br />
          <span style="color: red;">2、檔名禁止特殊符号</span>
          <br />
          <span style="color: red;">3、如要修改影片内容,需重新上传影片</span>
        </a-form-model-item>
        <a-form-model-item label="影片显示位置">
          <a-radio-group v-model="input.iscontenttop">
            <a-radio :value="1">顶部</a-radio>
            <a-radio :value="2">底部</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="影片链接文字">
          <editor v-model="input.linkmemo" placeholder="点击影片处显示文字" :type="2"></editor>
          <span style="color: red;">最多可填写50个字符</span>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-layout-content>
</template>

<script>
  import editor from "../../components/tools/wangEditor";
  export default {
    components: {
      editor,
    },
    data() {
      return {
        labelCol: { span: 3 },
        wrapperCol: { span: 10 },
        action: "add",
        input: {
          name: "",
          url: "",
          sort: "0",
          state: 1,
          showpc: 1,
          showphone: 1,
          limitcount: "0",
          limittip: "",
          activiesapply: 1,
          pcEditor: "",
          phoneEditor: "",
          id: 0,
          contentimg: "",
          contentvideo: "",
          videostate: 0,
          linkmemo: "",
          iscontenttop: "1",
        },
        imgfile: [],
        videofile: [],
        imgurl: "",
        visible: false,
      };
    },
    methods: {
      save() {
        let _this = this;
        var urlregex = /(http|https):\/\/([\w.]+\/?)\S*/;

        if (!urlregex.test(this.input.url) && this.input.url != "") {
          return _this.$message.error(this.input.url + "请输入正确的地址");
        }
        if (this.input.name == "") {
          return _this.$message.error("请输入活动名称");
        }
        let type = 1;
        let requestUrl = "";

        if (this.action == "add") {
          requestUrl = "/promotions/addpromotions";
          type = 1;
        } else if (this.action == "edit") {
          requestUrl = "/promotions/editpromotions";
          type = 2;
        }

        let params = {
          ID: this.input.id,
          Name: this.input.name,
          Url: this.input.url,
          Sort: this.input.sort,
          State: this.input.state,
          ShowPC: this.input.showpc,
          ShowPhone: this.input.showphone,
          ActiviesApply: this.input.activiesapply,
          Limitcount: this.input.limitcount,
          Limittip: this.input.limittip,
          PCConent: this.input.pcEditor,
          PhoneConent: this.input.phoneEditor,
          Image: this.input.image,
          Type: type,
          Contentimg: this.input.contentimg,
          Contentvideo: this.input.contentvideo,
          Videostate: this.input.videostate,
          Linkmemo: this.input.linkmemo,
          Iscontenttop: this.input.iscontenttop,
        };

        this.axios.post(requestUrl, params).then((res) => {
          if (res.data) {
            this.$message.success("保存成功");
          } else {
            this.$message.error(res.error);
          }
        });
      },
      query() {
        let params = {
          ID: parseInt(this.input.id),
        };

        this.axios.post("/promotions/getpromotionbyid", params).then((res) => {
          if (res.data) {
            (this.input.id = res.data[0].p_id),
              (this.input.name = res.data[0].p_activiesname),
              (this.input.url = res.data[0].p_url),
              (this.input.sort = res.data[0].p_sort),
              (this.input.state = res.data[0].p_state),
              (this.input.showpc = res.data[0].p_show),
              (this.input.showphone = res.data[0].p_phoneshow),
              (this.input.activiesapply = res.data[0].p_activiesapply),
              (this.input.limitcount = res.data[0].p_limitcount),
              (this.input.limittip = res.data[0].p_limittips),
              (this.input.pcEditor = res.data[0].p_content),
              (this.input.phoneEditor = res.data[0].p_phonecontent),
              (this.input.contentimg = res.data[0].p_contentimg),
              (this.input.contentvideo = res.data[0].p_contentvideo),
              (this.input.videostate = res.data[0].p_videostate),
              (this.input.linkmemo = res.data[0].p_linkmemo),
              (this.input.iscontenttop = res.data[0].p_iscontenttop);
            if (res.extend) {
              if (res.extend[0] != null) {
                this.imgurl = res.extend[0];
              }
              else{
                this.imgurl = "";
              }         
            }
          }
          else {
            this.$message.error(res.error);
          }
        });
      },
      changeimg(file) {
        console.log(file);
      },
      swichstate(val, flag) {
        if (flag == "state") {
          this.input.state = val ? 1 : 0;
        } else if (flag == "showpc") {
          this.input.showpc = val ? 1 : 0;
        } else if (flag == "showphone") {
          this.input.showphone = val ? 1 : 0;
        } else if (flag == "activiesapply") {
          this.input.activiesapply = val ? 1 : 0;
        } else if (flag == "videostate") {
          this.input.videostate = val ? 1 : 0;
        }
      },
      clearinput() {
        this.input.id = 0;
        this.input.name = "";
        this.input.url = "";
        this.input.sort = "0";
        this.input.state = 1;
        this.input.showpc = 1;
        this.input.showphone = 1;
        this.input.activiesapply = 1
        this.input.limitcount = "0";
        this.input.limittip = "";
        this.input.pcEditor = "";
        this.input.phoneEditor = "";
        this.input.contentimg = "";
        this.input.contentvideo = "";
        this.input.videostate = 0;
        this.input.linkmemo = "";
        this.input.iscontenttop = "1";
        this.imgfile = [];
        this.videofile = [];
        this.imgurl = "";
      },
      //上传影片弹窗
      uploadvideomodel() {
        this.visible = true;
      },
      modelOK() {
        this.visible = false;
      },
      //上传图片
      UploadImg(file) {
        if (!this.isExcel(file, 1)) {
          this.$message.error("仅支持上传.jpg、.png、.gif、后缀文件");
          return false;
        }
        this.imgfile = [file];
        return false;
      },
      //上传影片
      UploadVideo(file) {
        if (!this.isExcel(file, 2)) {
          this.$message.error("仅支持上传.mp4");
          return false;
        }
        this.videofile = [file];
        return false;
      },
      isExcel(file, type) {
        if (type == 1) {
          return /\.(jpg|png|gif)$/.test(file.name);
        }
        else if (type == 2) {
          return /\.(mp4)$/.test(file.name);
        }
      },
      //删除图片
      imgRemove(file) {
        const index = this.imgfile.indexOf(file);
        const newFileList = this.imgfile.slice();
        newFileList.splice(index, 1);
        this.imgfile = newFileList;
      },
      //删除影片
      videoRemove(file) {
        const index = this.videofile.indexOf(file);
        const newFileList = this.videofile.slice();
        newFileList.splice(index, 1);
        this.videofile = newFileList;
      },
      //开始上传
      UploadOK(flag) {
        let param = new FormData();
        if (flag == 1) {
          if (this.imgfile.length > 0) {
            param.append(
              "files", this.imgfile[0],
              "." + this.imgfile[0].name.split(".")[1]
            );
          }
        } else if (flag == 2) {
          if (this.videofile.length > 0) {
            param.append(
              "files", this.videofile[0],
              "." + this.videofile[0].name.split(".")[1]
            );
          }
        }

        param.append("id", this.input.id); // 添加form表单中其他数据
        let config = {
          headers: { "Content-Type": "multipart/form-data" },
        };
        // 添加请求头
        let _this = this;
        this.axios.post(flag == 1 ? "/promotions/uploadcontentimage" : "/promotions/uploadcontentvideo", param, config).then((res) => {
          if (flag == 1) {
            if (res.data == "0") {
              _this.imgurl = res.imgurl;
              _this.input.contentimg = res.imgpath;
              _this.$message.success("上传成功");
            }
          }
          else {
            if (res.data) {
              _this.input.contentvideo = res.videopath;
              _this.$message.success("上传成功");
            }
          }
        });
      },
      //复制文字
      copyContent(text) {
        if (text != "") {
          navigator.clipboard.writeText(text);
          this.$message.success("已复制");
        }
      }
    },
    watch: {
      $route(to, from) {
        if (to.name === "createactivie") {
          this.action = this.$route.params.action;
          this.input.id = this.$route.params.id;

          if (this.action == "edit") {
            this.query();
          } else {
            this.action = "add";
            this.clearinput();
          }
        }

      },
    },
    created() {
      if (this.$route.params.action === "edit") {
        this.action = this.$route.params.action;
        this.input.id = this.$route.params.id;
        this.query();
      }
      else {
        this.clearinput();
      }
    },
  };
</script>

<style lang="css">
  .upload-list-inline :deep(.ant-upload-list-item) {
    float: left;
    width: 200px;
    margin-right: 8px;
  }

  .upload-list-inline [class*="-upload-list-rtl"] :deep(.ant-upload-list-item) {
    float: right;
  }
</style>


// WEBPACK FOOTER //
// src/components/promotions/createactivie.vue